module.exports = __webpack_public_path__ + "img/right-arrow.625018dc.svg";